import {useState, useRef, useEffect} from 'react';
import CardList from './CardList';
import './css/Home.css';
import 'bootstrap/dist/css/bootstrap.css';
import uniqueId from 'lodash/uniqueId';
import Navbar from './Navbar';
import {allPaws, handleFilters, handleSearch} from './Firebase';
import Popup from './Popup';


function App() {
  const [cards, setCards] = useState([]);
  const [data, setData] = useState([]);
  const [searchKey, setSearchKey] = useState('');
  const [filterState, setFilterState] = useState(false);
  const [filter, setFilter] = useState([true, true, false, false, false, false, false, false, false, false, false, false, false, 
    false, false, false, false, false, false, false, false, false, false, false]);
  const [buttonVisible, setButtonVisible] = useState("homeButton");
 
  
  const childToParent = async (childData) => {
    setSearchKey(childData);
    console.log(searchKey);
    const paws = await handleSearch(searchKey);
    setData(paws.docs.map(doc => doc.data()));
    setCards(data.map(animal => (
      {id: uniqueId('card_') , name: animal.name, imageUrl: animal.imageUrl, breed: animal.breed, sex: animal.sex, size: animal.size, age: animal.age, shelterID: animal.shelterID}
    )))
  }

  const childToParentFilterState = (childData) => {
    setFilterState(childData);
    console.log(filterState);
  }


  const fetchAllAnimals = async () => {
    const paws = await allPaws();
    setData(paws.docs.map(doc => doc.data()));
    setCards(data.map(animal => (
      {id: uniqueId('card_') , name: animal.name, imageUrl: animal.imageUrl, breed: animal.breed, sex: animal.sex, size: animal.size, age: animal.age, shelterID: animal.shelterID}
    )))
    
  }







  const childToParentAppliedFilters = (childData) => {
    setFilter(childData);
    console.log("Wow");

  }

  const showAnimals = () => {
    showFilteredAnimals();
    setButtonVisible("homeButtonHidden");
  }

  const showFilteredAnimals = async () => {
    console.log(filter[1])
    const paws = await handleFilters(filter);

      console.log("insisde")
      setData([]);
      setCards([]);
      setData(paws.docs.map(doc => doc.data()));
      setCards(data.map(animal => (
        {id: uniqueId('card_') , name: animal.name, imageUrl: animal.imageUrl, breed: animal.breed, sex: animal.sex, 
        size: animal.weight, age: animal.age, shelterId: animal.shelterId}
        )))
  }

  useEffect(async () => {
    showFilteredAnimals();
  }, [filter, filterState])


  return ( 
    <>
      <Navbar childToParent={childToParent} childToParentFilterState={childToParentFilterState}></Navbar>
      <div className = "imgContainer">
      <img className = "banner" src= "https://images.pexels.com/photos/10264364/pexels-photo-10264364.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260" alt=''></img> 
      <h1 className="imgText"> 110 Paws near you</h1> 
      </div> 
      <Popup trigger = {filterState} setTrigger={setFilterState} childToParentAppliedFilters={childToParentAppliedFilters}></Popup>
      <button className={buttonVisible} type ="button" onClick = {showAnimals}>Find your new 4 legged Bestie!</button>
      <div className='container'><CardList cards = {cards}/></div>
    </>
  );
}

export default App;
